export default "__VITE_ASSET__DEA4Mdap__"